import { useTranslation } from 'react-i18next';

export const CheckingPage = () => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <div className="flex flex-col items-center gap-6">
                <div className="flex gap-2 items-end">
                    <div className="w-3 h-3 bg-primary rounded-full animate-bounce [animation-delay:0ms]"></div>
                    <div className="w-3 h-3 bg-primary rounded-full animate-bounce [animation-delay:150ms]"></div>
                    <div className="w-3 h-3 bg-primary rounded-full animate-bounce [animation-delay:300ms]"></div>
                </div>
                <div className="text-lg font-medium text-sub">{t('common.checkingAccess')}</div>
            </div>
        </div>
    );
};
